export default {"src":"/_next/static/media/planet.fb43e317.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};